import { render, staticRenderFns } from "./C4aStatus.vue?vue&type=template&id=161f2ae5"
import script from "./C4aStatus.vue?vue&type=script&setup=true&lang=js"
export * from "./C4aStatus.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports